<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-button class="item" icon="icon icon-jiarucopy" @click="on_create()" type="primary" />
                <a-divider type="vertical" class="item" />

                <a-button
                    class="item"
                    ref="delete"
                    type="danger"
                    icon="delete"
                    secondary
                    @click="on_delete(selected_rows)"
                    :disabled="!selected_row_keys.length"
                />
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
            >
                <template slot="avatar_render" slot-scope="text">
                    <img v-if="text" :src="text" class="avatar" />
                </template>

                <template slot="status_render" slot-scope="text">
                    <a-tag v-if="text == 1" color="green" class="b-tag">启用</a-tag>
                    <a-tag v-else class="b-tag">禁用</a-tag>
                </template>

                <template slot="default" slot-scope="text">
                    <a-icon type="check" v-if="text" />
                </template>

                <template slot="qrcode" slot-scope="text">
                    <a-tooltip v-if="text">
                        <template slot="title">
                            <img width="180" height="180" :src="text" />
                        </template>
                        <a-icon type="qrcode" />
                    </a-tooltip>
                </template>

                <!-- 创建时间 -->
                <template slot="created_render" slot-scope="text, record">
                    <span v-html="$options.filters['friendly'](moment(text * 1000).format('YYYY-MM-DD HH:mm'))"></span>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-button :disabled="!!record.is_default" size="small" style="margin-right: 5px" @click="on_default(record)"
                            >默认</a-button
                        >

                        <a-button v-if="record.status == 0" size="small" style="margin-right: 5px" @click="on_status(record, 1)"
                            >启用</a-button
                        >
                        <a-button v-if="record.status == 1" size="small" style="margin-right: 5px" @click="on_status(record, 0)"
                            >禁用</a-button
                        >
                        <a-button size="small" style="margin-right: 5px" @click="on_edit(record)">修改</a-button>
                        <a-button size="small" @click="on_delete([record])" type="danger" :disabled="!!record.customer_count"
                            >删除</a-button
                        >
                    </div>
                </template>
            </a-table>
        </div>

        <modal_create
            :visible="visible_create"
            @load="load"
            @close="visible_create = false"
            :record="selected_record"
            :mode="mode_create"
        />
    </div>
</template>

<script>
    import modal_create from "./modal_create.vue";
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";

    export default {
        mixins: [common_pagination],
        components: {
            modal_create,
        },
        data() {
            return {
                path: "/setting/authority/service",
                data_source: [],
                loading: false,
                visible_create: false,
                mode_create: "create",
                selected_record: null,
                wd: null,
                columns: [
                    {
                        dataIndex: "status",
                        width: 60,
                        title: "状态",
                        align: "center",
                        scopedSlots: {
                            customRender: "status_render",
                        },
                    },
                    {
                        dataIndex: "is_default",
                        width: 60,
                        title: "默认",
                        align: "center",
                        scopedSlots: {
                            customRender: "default",
                        },
                    },
                    {
                        dataIndex: "user.name",
                        width: 120,
                        title: "关联用户",
                    },
                    {
                        dataIndex: "avatar",
                        width: 70,
                        title: "头像",
                        scopedSlots: {
                            customRender: "avatar_render",
                        },
                    },
                    {
                        dataIndex: "name",
                        width: 90,
                        title: "姓名",
                    },
                    {
                        dataIndex: "no",
                        width: 90,
                        title: "工号",
                        customRender: (e) => e || "",
                    },
                    {
                        dataIndex: "mobile",
                        width: 120,
                        title: "电话",
                    },
                    {
                        dataIndex: "qq",
                        width: 120,
                        title: "QQ",
                    },
                    {
                        dataIndex: "wechat_id",
                        width: 150,
                        title: "微信号",
                    },
                    {
                        dataIndex: "wechat_qrcode",
                        width: 90,
                        title: "微信二维码",
                        scopedSlots: {
                            customRender: "qrcode",
                        },
                    },
                    {
                        dataIndex: "description",
                        title: "描述",
                        class: "small",
                    },
                    // {
                    //     dataIndex: "created_at",
                    //     title: "创建时间",
                    //     width: 150,
                    //     customRender: (e) => moment(e * 1000).format("YYYY-MM-DD HH:mm"),
                    // },
                    {
                        dataIndex: "action",
                        title: "操作",
                        align: "center",
                        width: 230,
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        mounted() {
            this.load();
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/auth/service?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_status(record, status) {
                this.$http
                    .post(`/auth/service/status`, { user_id: record.user_id, status: status })
                    .then((res) => {
                        if (res.success) {
                            this.load();
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_edit(row) {
                this.selected_record = row;
                this.mode_create = "edit";
                this.visible_create = true;
            },
            on_create() {
                this.selected_record = {};
                this.visible_create = true;
                this.mode_create = "create";
            },
            on_default(record) {
                this.$confirm({
                    centered: true,
                    title: "操作确认",
                    content: `是否设置【${record.name}】为默认客服`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .post("/auth/service/default", { user_id: record.user_id })
                                .then((res) => {
                                    if (!res.success) {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: "删除确认",
                    content: `是否删除选中的客服`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete("/auth/service/" + record.map((v) => v.id).join(","))
                                .then((res) => {
                                    if (!res.success) {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
    .banner {
        max-height: 30px;
    }

    .sort {
        display: flex;
        .btn {
            &:first-child {
                margin-right: 8px;
            }
        }
    }
</style>
